import React, { useState } from "react";
import "../styles/Legend.css";

const Legend = ({ stats, filteredCount }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`legend ${isOpen ? "open" : "closed"}`}>
      <button className="legend-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "Hide Legend ▼" : "Legend ▲"}
      </button>

      <div className="legend-content">
        <h3 className="legend-title">Legend</h3>

        <div className="legend-section">
          <h4 className="legend-subtitle">Cluster Colors (zoomed out)</h4>
          <div className="gradient-bar">
            <div className="gradient-visual"></div>
            <div className="gradient-labels">
              <span>Few Reports</span>
              <span>Many Reports</span>
            </div>
          </div>
        </div>

        <div className="legend-section">
          <h4 className="legend-subtitle">Individual Reports (zoomed in)</h4>
          <div className="legend-items">
            <div className="legend-item">
              <div
                className="legend-circle"
                style={{ background: "#e74c3c" }}
              ></div>
              <span>Carcinogen Report</span>
            </div>
            <div className="legend-item">
              <div
                className="legend-circle"
                style={{ background: "#3498db" }}
              ></div>
              <span>Non-Carcinogen Report</span>
            </div>
          </div>
        </div>

        <div className="legend-stats">
          <div className="stat-item">
            <strong>Displayed:</strong> {filteredCount.toLocaleString()}
          </div>
          <div className="stat-item">
            <strong>Total:</strong> {stats.total.toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legend;
